// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__-XYZQ","DesktopOnly":"NavBar_DesktopOnly__7kwVV"};